<template>
  <b-navbar-nav>
    <li v-for="(route, index) in menu" :key="index" class="list-inline-item">
      <menuItem :route="route" :key="'itemIndex' + index" />
    </li>
  </b-navbar-nav>
</template>

<script>
import { primary } from '../nav'
import menuItem from './main_menu_item'

export default {
  components: { menuItem },
  data () {
    return {
      menu: primary
    }
  }
}
</script>

<style lang="scss">
.dropdown-item {
  padding-inline: .5rem;
}
</style>
